// ============================================
// SECURITY PROTECTION MODULE
// ============================================
// Disuasión anti-inspect para usuarios casuales.
// NOTA: Estas protecciones son DISUASORIAS, no infalibles.
// Un usuario técnico avanzado puede saltarlas, pero detienen al 90% de curiosos.

const SECURITY_CONFIG = {
  // Mostrar warning en consola
  enableConsoleWarning: true,
  // Bloquear click derecho
  blockRightClick: true,
  // Bloquear atajos de teclado (F12, Ctrl+Shift+I, etc)
  blockKeyboardShortcuts: true,
  // Bloquear drag de imágenes
  blockImageDrag: true,
  // Bloquear selección de texto en zonas sensibles
  blockTextSelection: false, // Lo dejamos false para no romper UX
  // Detectar DevTools abierto
  detectDevTools: true,
  // Limpiar consola periódicamente
  clearConsole: true,
}

// ============================================
// 1. CONSOLE WARNING
// ============================================
function showConsoleWarning() {
  const warningStyle1 =
    'color: #C5A028; font-size: 50px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);'
  const warningStyle2 = 'color: #ff4444; font-size: 18px; font-weight: bold;'
  const warningStyle3 = 'color: #ffffff; font-size: 14px;'

  console.log('%c⚠️ ALTO', warningStyle1)
  console.log(
    '%cEsta es una función del navegador destinada a desarrolladores.',
    warningStyle2,
  )
  console.log(
    '%cSi alguien te dijo que copies o pegues algo aquí para "hackear" o "ver información", es una ESTAFA y les darías acceso a tu información personal.',
    warningStyle3,
  )
  console.log(
    '%c\nContenido protegido por derechos de autor © Alexaaa Narvaez 2026',
    'color: #C5A028; font-size: 12px; font-style: italic;',
  )
}

// ============================================
// 2. BLOCK RIGHT CLICK
// ============================================
function blockRightClick() {
  document.addEventListener(
    'contextmenu',
    (e) => {
      e.preventDefault()
      return false
    },
    { capture: true },
  )
}

// ============================================
// 3. BLOCK KEYBOARD SHORTCUTS
// ============================================
function blockKeyboardShortcuts() {
  document.addEventListener(
    'keydown',
    (e) => {
      // F12 - DevTools
      if (e.key === 'F12') {
        e.preventDefault()
        return false
      }

      // Ctrl+Shift+I / Cmd+Opt+I - DevTools
      if (
        (e.ctrlKey || e.metaKey) &&
        e.shiftKey &&
        (e.key === 'I' || e.key === 'i')
      ) {
        e.preventDefault()
        return false
      }

      // Ctrl+Shift+J / Cmd+Opt+J - Console
      if (
        (e.ctrlKey || e.metaKey) &&
        e.shiftKey &&
        (e.key === 'J' || e.key === 'j')
      ) {
        e.preventDefault()
        return false
      }

      // Ctrl+Shift+C / Cmd+Shift+C - Inspector
      if (
        (e.ctrlKey || e.metaKey) &&
        e.shiftKey &&
        (e.key === 'C' || e.key === 'c')
      ) {
        e.preventDefault()
        return false
      }

      // Ctrl+U / Cmd+U - View Source
      if ((e.ctrlKey || e.metaKey) && (e.key === 'U' || e.key === 'u')) {
        e.preventDefault()
        return false
      }

      // Ctrl+S / Cmd+S - Save Page
      if ((e.ctrlKey || e.metaKey) && (e.key === 'S' || e.key === 's')) {
        e.preventDefault()
        return false
      }
    },
    { capture: true },
  )
}

// ============================================
// 4. BLOCK IMAGE DRAG
// ============================================
function blockImageDrag() {
  document.addEventListener('dragstart', (e) => {
    const target = e.target as HTMLElement
    if (target.tagName === 'IMG') {
      e.preventDefault()
      return false
    }
  })

  // También bloquear el clic prolongado en mobile (long-press para guardar)
  const style = document.createElement('style')
  style.textContent = `
    img {
      -webkit-user-drag: none;
      -khtml-user-drag: none;
      -moz-user-drag: none;
      -o-user-drag: none;
      user-drag: none;
      -webkit-touch-callout: none;
    }
  `
  document.head.appendChild(style)
}

// ============================================
// 5. DETECT DEVTOOLS OPEN
// ============================================
function detectDevTools() {
  const threshold = 160
  let devtoolsOpen = false

  const checkDevTools = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold
    const heightThreshold = window.outerHeight - window.innerHeight > threshold

    if (widthThreshold || heightThreshold) {
      if (!devtoolsOpen) {
        devtoolsOpen = true
        handleDevToolsOpen()
      }
    } else {
      devtoolsOpen = false
    }
  }

  // Check periodically
  setInterval(checkDevTools, 1000)
}

function handleDevToolsOpen() {
  // Limpia consola repetidamente
  if (SECURITY_CONFIG.clearConsole) {
    setInterval(() => {
      console.clear()
      showConsoleWarning()
    }, 500)
  }
}

// ============================================
// 6. CONSOLE CLEAR LOOP
// ============================================
function startConsoleClearLoop() {
  // Limpia la consola cada 3 segundos
  setInterval(() => {
    console.clear()
    showConsoleWarning()
  }, 3000)
}

// ============================================
// 7. DISABLE COPY (opcional - lo dejamos suave)
// ============================================
function disableCopy() {
  // Solo bloquear copia de imágenes, no de texto (mejor UX)
  document.addEventListener('copy', (e) => {
    const selection = window.getSelection()?.toString() || ''
    // Si la selección es muy larga (copia masiva), bloquear
    if (selection.length > 200) {
      e.preventDefault()
      return false
    }
  })
}

// ============================================
// MAIN INITIALIZER
// ============================================
export function initSecurityProtection() {
  if (typeof window === 'undefined') return

  // Solo activar en producción (no romper desarrollo)
  const isProduction =
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1' &&
    !window.location.hostname.includes('magicpatterns.app') // permitir preview

  if (!isProduction) {
    console.log('🔓 Security protection disabled in development mode')
    return
  }

  // Activar todas las protecciones configuradas
  if (SECURITY_CONFIG.enableConsoleWarning) {
    showConsoleWarning()
  }

  if (SECURITY_CONFIG.blockRightClick) {
    blockRightClick()
  }

  if (SECURITY_CONFIG.blockKeyboardShortcuts) {
    blockKeyboardShortcuts()
  }

  if (SECURITY_CONFIG.blockImageDrag) {
    blockImageDrag()
  }

  if (SECURITY_CONFIG.detectDevTools) {
    detectDevTools()
  }

  if (SECURITY_CONFIG.clearConsole) {
    startConsoleClearLoop()
  }

  disableCopy()
}
